// Sesiune 33 batch B opt 2: foloseste origin-ul curent al browser-ului ca default,
// pentru ca acelasi build sa functioneze pe staging.amel-online.ro si pe productie
// fara configurare per environment. REACT_APP_API_URL este folosit doar in dev local.
export const API_URL = process.env.REACT_APP_API_URL || (typeof window !== 'undefined' ? window.location.origin : '');

export const fetchApi = async (endpoint, options = {}) => {
  const token = localStorage.getItem('oferte_token');
  
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers,
  });
  
  if (response.status === 401) {
    localStorage.removeItem('oferte_token');
    localStorage.removeItem('oferte_user');
    window.location.href = '/login';
    return null;
  }
  
  return response;
};
